export default __webpack_public_path__ + "static/media/footer_CfR.402be56f.svg";